// lib/leasing/enrichingDims.ts
//
// Which fields of a brand are being researched right now, whoever started it (the agent, a panel
// click, the research pass). The brand card pulses exactly those rows, so live work shows on the
// data itself rather than as a canned chat note.
type EnrichingState = { sourceEnrichingDims?: Record<string, string[]> };
type Setter = { setState: (fn: (state: EnrichingState) => Partial<EnrichingState>) => void };

export const markEnriching = (k: Setter | null | undefined, brandId: string, dims: readonly string[], on: boolean): void => {
  k?.setState((state) => {
    const current = state.sourceEnrichingDims ?? {};
    const held = current[brandId] ?? [];
    const next = on ? [...held, ...dims] : held.filter((dim, index) => {
      // Remove ONE occurrence per dim, so two overlapping calls on the same field keep it pulsing.
      const at = dims.indexOf(dim);
      return at === -1 || held.indexOf(dim) !== index;
    });
    const rest = { ...current };
    if (next.length > 0) rest[brandId] = next;
    else delete rest[brandId];
    return { sourceEnrichingDims: rest };
  });
};
